module.exports = __webpack_public_path__ + "img/Niehaus@3x.d0b04e60.png";